const codes = [
    ['H', 'Ungarn'],
    ['EST', 'Estland'],
    ['PL', 'Polen'],
    ['S', 'Sverige'],
    ['LT', 'Litauen'],
    ['CZ', 'Tsjekkia'],
    ['RUS', 'Russland'],
    ['D', 'Tyskland'],
    ['DK', 'Danmark'],
    ['P', 'Portugal'],
    ['A', 'Østerrike'],
    ['AFG', 'Afghanistan'],
    ['AL', 'Albania'],
    ['AND', 'Andorra'],
    ['AUS', 'Australia'],
    ['B', 'Belgia'],
    ['BD', 'Bangladesh'],
    ['BDS', 'Barbados'],
    ['BF', 'Burkina, Faso'],
    ['BG', 'Bulgaria'],
    ['BIH', 'Bosnia-Hercegovina'],
    ['BOL', 'Bolivia'],
    ['BR', 'Brasil'],
    ['BRN', 'Bahrain'],
    ['BRU', 'Brunei'],
    ['BS', 'Bahamas'],
    ['BY', 'Hviterussland'],
    ['BZ', 'Belize'],
    ['C', 'Cuba'],
    ['CAM', 'Kamerun'],
    ['CDN', 'Canada'],
    ['CH', 'Sveits'],
    ['CI', 'Elfenbenskysten'],
    ['CL', 'Sri, Lanka'],
    ['CO', 'Colombia'],
    ['CR', 'Costa, Rica'],
    ['CY', 'Kypros'],
    ['DOM', 'Dominikanske, republikk'],
    ['DY', 'Benin'],
    ['DZ', 'Algerie'],
    ['E', 'Spania'],
    ['EAK', 'Kenya'],
    ['EAT', 'Tanzania'],
    ['EAU', 'Uganda'],
    ['EC', 'Ecuador'],
    ['ER', 'Eritrea'],
    ['ES', 'El, Salvador'],
    ['ET', 'Egypt'],
    ['ETH', 'Etiopia'],
    ['F', 'Frankrike'],
    ['FIN', 'Finland'],
    ['FJI', 'Fiji'],
    ['FL', 'Liechtenstein'],
    ['FO', 'Færøyene'],
    ['G', 'Gabon'],
    ['GB', 'Storbritannia'],
    ['GBA', 'Alderney'],
    ['GBG', 'Guernsey'],
    ['GBJ', 'Jersey'],
    ['GBM', 'Man'],
    ['GBZ', 'Gibraltar'],
    ['GCA', 'Guatemala'],
    ['GH', 'Ghana'],
    ['GR', 'Hellas'],
    ['GUY', 'Guyana'],
    ['HK', 'Hongkong'],
    ['HKJ', 'Jordan'],
    ['I', 'Italia'],
    ['IL', 'Israel'],
    ['IND', 'India'],
    ['IR', 'Iran'],
    ['IRL', 'Irland'],
    ['IRQ', 'Irak'],
    ['IS', 'Island'],
    ['J', 'Japan'],
    ['JA', 'Jamaica'],
    ['K', 'Kambodsja'],
    ['KS', 'Kirgisistan'],
    ['KWT', 'Kuwait'],
    ['L', 'Luxembourg'],
    ['LAO', 'Laos'],
    ['LAR', 'Libya'],
    ['LB', 'Liberia'],
    ['LS', 'Lesotho'],
    ['LV', 'Latvia'],
    ['M', 'Malta'],
    ['MA', 'Marokko'],
    ['MAL', 'Malaysia'],
    ['MC', 'Monaco'],
    ['MD', 'Moldova'],
    ['MEX', 'Mexico'],
    ['MK', 'Makedonia'],
    ['MOC', 'Mosambik'],
    ['MS', 'Mauritius'],
    ['MW', 'Malawi'],
    ['MYA', 'Myanmar'],
    ['N', 'Norge'],
    ['NA', 'Nederlandske, Antiller'],
    ['NAM', 'Namibia'],
    ['NAU', 'Nauru'],
    ['NEP', 'Nepal'],
    ['NGR', 'Nigeria'],
    ['NIC', 'Nicaragua'],
    ['NL', 'Nederland'],
    ['NZ', 'New, Zealand'],
    ['OM', 'Oman'],
    ['PA', 'Panama'],
    ['PE', 'Peru'],
    ['PK', 'Pakistan'],
    ['PNG', 'Papua, Ny-Guinea'],
    ['PY', 'Paraguay'],
    ['Q', 'Qatar'],
    ['RA', 'Argentina'],
    ['RB', 'Botswana'],
    ['RC', 'Taiwan'],
    ['RCA', 'Sentralafrikanske, republikk'],
    ['RCB', 'Kongo, (Brazzaville)'],
    ['RCH', 'Chile'],
    ['RG', 'Guinea'],
    ['RH', 'Haiti'],
    ['RI', 'Indonesia'],
    ['RIM', 'Mauritania'],
    ['RL', 'Libanon'],
    ['RM', 'Madagaskar'],
    ['RMM', 'Mali'],
    ['RN', 'Niger'],
    ['RO', 'Romania'],
    ['ROK', 'Sør-Korea'],
    ['ROU', 'Uruguay'],
    ['RP', 'Filippinene'],
    ['RSM', 'San, Marino'],
    ['RU', 'Burundi'],
    ['RUC', 'Kamerun'],
    ['RWA', 'Rwanda'],
    ['SA', 'Saudi-Arabia'],
    ['SD', 'Swaziland'],
    ['SGP', 'Singapore'],
    ['SK', 'Slovakia'],
    ['SLO', 'Slovenia'],
    ['SME', 'Surinam'],
    ['SN', 'Senegal'],
    ['SO', 'Somalia'],
    ['SUD', 'Sudan'],
    ['SY', 'Seychellene'],
    ['SYR', 'Syria'],
    ['T', 'Thailand'],
    ['TCH', 'Tsjad'],
    ['TG', 'Togo'],
    ['TJ', 'Tadsjikistan'],
    ['TM', 'Turkmenistan'],
    ['TN', 'Tunisia'],
    ['TR', 'Tyrkia'],
    ['TT', 'Trinidad, og, Tobago'],
    ['UA', 'Ukraina'],
    ['UAE', 'Forente, arabiske, emirater'],
    ['USA', 'USA'],
    ['UZ', 'Usbekistan'],
    ['V', 'Vatikanstaten'],
    ['VN', 'Vietnam'],
    ['WAG', 'Gambia'],
    ['WAL', 'Sierra, Leone'],
    ['WD', 'Dominica'],
    ['WG', 'Grenada'],
    ['WL', 'Saint, Lucia'],
    ['WS', 'Samoa'],
    ['WV', 'Saint, Vincent, og, Grenadinene'],
    ['YAR', 'Jemen'],
    ['YU', 'Jugoslavia'],
    ['YV', 'Venezuela'],
    ['Z', 'Zambia'],
    ['ZA', 'Sør-Afrikarepublikken'],
    ['ZRE', 'Den, demokratiske, republikken, Kongo, (tidl., Zaire)'],
    ['ZW', 'Zimbabwe'],
    ['CC', 'Corps, Consulaire'],
    ['CD', 'Corps, Diplomatique']
]

export default codes;


// WEBPACK FOOTER //
// ./src/CountryCodes.js